/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/003-home3': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 9.5l-3-3V2h-2v2.5l-3-3-8 8v.5h2v5h5v-3h2v3h5v-5h2z"/>'
  }
})
